export default {
  dentalServiceType: Object.freeze({
    CONSULTATION: 'consultation', TREATMENT: 'treatment', SNAPSHOT: 'snapshot', SELLING: 'selling',
    PREPAYMENT: 'prepayment',
  }),
}
